/**
 * The "when" half of a settings card's "Last changed by …" line — one
 * format for every card on the Settings page ("Oct 26, 2:14 PM", in the
 * viewer's locale and clock), so two lines on one screen never disagree.
 * Moved out of OperationsSettingsCard so the Required vaccinations section
 * (SPEC 2026-10-26 AC 1.9) reuses it without a circular import.
 *
 * Returns '' for a value that is not a date: the line then names who, not a
 * garbled when (Principle 5 — never show an ISO string or "Invalid Date").
 */
export function whenLabel(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).format(d);
}
